// Date 2025-02-22 10:12:25

import ppeInventory from "@/store/em/ppe/PpeInventoryStore.js";
import ppeApplyRecord from "@/store/em/ppe/PpeApplyRecordStore.js";
import ppeApplyRecordDetail from "@/store/em/ppe/PpeApplyRecordDetailStore.js";
import ppeApplyRecordHistory from "@/store/em/ppe/PpeApplyRecordHistoryStore.js";
import ppeApplyScrap from "@/store/em/ppe/PpeApplyScrapStore.js";
import ppeApplyScrapDetail from "@/store/em/ppe/PpeApplyScrapDetailStore.js";
import ppeDeptManagerDict from "@/store/em/ppe/PpeDeptManagerDictStore.js";

const genericEntities = [
    'ppeInventory',
    'ppeApplyRecord',
    'ppeApplyRecordDetail',
    'ppeApplyRecordHistory',
    'ppeApplyScrap',
    'ppeApplyScrapDetail',
    'ppeDeptManagerDict'
]

const entities = {
    ppeInventory,
    ppeApplyRecord,
    ppeApplyRecordDetail,
    ppeApplyRecordHistory,
    ppeApplyScrap,
    ppeApplyScrapDetail,
    ppeDeptManagerDict
}

export {genericEntities}

export default entities